var XMLNode = require("../xml/XMLNode");

/**
 * This class represents border configuration for Office Open XML Spreadsheets.
 * @constructor
 */
function Border() {
	XMLNode.call(this, Border.metadata);
}

Border.prototype = Object.create(XMLNode.prototype);
Border.prototype.constructor = Border;

Border.metadata = {
	tag: "border",
	properties: [
		{
			tag: "left"
		},
		{
			tag: "right"
		},
		{
			tag: "top"
		},
		{
			tag: "bottom"
		},
		{
			tag: "diagonal"
		}
	]
};

/**
 * Checks if the current Border is equal to the given parameter.
 *
 * @param {Border} oBorder Border that get"s compared to the current one
 * @return {boolean} Returns true if both Borders have the same configuration
 */
Border.prototype.equals = function(oBorder) {

	/**
	 * Once it is a Border object we always return true because we
	 * don't provide more than one border type
	 */
	return oBorder instanceof Border;
};

module.exports = Border;